export const BlacklistParameters = {
  From: 'Filter.From',
  To: 'Filter.To',
  TextSearch: 'Filter.TextSearch',
  Reason: 'Filter.Reason',
  PageIndex: 'PageIndex',
  PageSize: 'PageSize',
  SortKeySelector: 'SortKeySelector',
  SortOrder: 'SortOrder',
};
